module.exports = __webpack_public_path__ + "img/6.3a742e05.jpg";